import $store from '@/store'

import EventModel from './event.js'
import SettingsModel from './settings.js'
import External from './external.js'


export default {
	list_active_channels() {
		return _.filter(Object.values($store.state.channels), (channel) => { return channel.state == "active"; });
	},
	get_channel(channel) {
		if (typeof(channel) == "object") return channel;
		return this.channel_by_id(channel);
	},
	channel_by_id (channel_id) {
  	return $store.state.channels[channel_id];
	},
	channel_by_uuid (channel_uuid) {
		return $store.state.channels_uuid[channel_uuid];
	},
	not_empty(data) {
		return typeof(data) != "undefined" && data != null;
	},
	title (channel) {
		var ch = this.get_channel(channel);
		if (this.not_empty(ch)) {
    	return ch.title;
    } else {
      return "";
    }
	},
	get_type (channel) {
		var ch = this.get_channel(channel);
		if (this.not_empty(ch)) {
			return ch.type;
		}
		return "";
	},
	is_transcoder(channel) {
		var ch = this.get_channel(channel);
		if (this.not_empty(ch)) {
    	return ch.transcoder == true;
    }
   	return false;
	},
	is_cloudstreamer (channel) {
		if (this.get_type(channel) == "input" && this.is_transcoder(channel)) return true;
    return false;
  },
	is_pull(channel) {
		var ch = this.get_channel(channel);
		if (this.not_empty(ch)) {
			return ch.meta.use_pull;
		}
		return false;
	},
	is_admin(channel) {
		var ch = this.get_channel(channel);
		if (this.not_empty(ch)) {
			return ch.meta.is_admin_channel;
		}
		return false;
	},
	is_mediaconnects(channel) {
		var ch = this.get_channel(channel);
		if (this.not_empty(ch)) {
			return ch.meta.use_mediaconnect == true && !_.isEmpty(ch.meta.mediaconnect_arns);
		}
		return false;
	},
	get_channel_input(channel, event) {
		var ch = this.get_channel(channel);
		if (this.not_empty(ch)) {
			var input_key = "default"; // Tähän inputin nimen haku eventin mukaan
			return {key: input_key, config: _.get(ch, ["configuration", "input", input_key], {})};
		}
		return undefined
	},
	status (channel) {
		var ch = this.get_channel(channel);
		if (typeof(ch) == "undefined") return;
		return $store.state.channel_status[ch.uuid];
	},
	mediaconnects_status(channel) {
		var ch = this.get_channel(channel);
		if (!this.not_empty(ch) || ch.meta.use_mediaconnect != true || _.isEmpty(ch.meta.mediaconnect_arns)) return;
		return _.map(ch.meta.mediaconnect_arns.split(","), (arn) => { return {arn: arn, ...$store.state.mediaconnects_status[arn.trim()]}; });
	},
	start_transcoder (channel, success, fail) {
		var ch = this.get_channel(channel);
    $store.dispatch("send_control", {"type": "transcoder", "payload": {"type": "start", "channel": ch.uuid}}).then((msg) => {
			success(msg)
    }).catch((msg) => {
    	fail(msg);
    });
  },
  outputs_list (channel) {
  	var ch = this.get_channel(channel);
  	if (this.not_empty(ch)) {
  		var outputs = _.get(ch, "configuration.output.outputs", []);
  		if (_.isArray(outputs)) return outputs;
  		return Object.values(outputs);
  	}
  	return [];
  },
	instance (channel, event) {
		var ch = this.get_channel(channel);
		if (this.not_empty(ch)) {
			if (this.is_transcoder(ch) == true && event && ch.type == "output") {
      	var instance = $store.getters.instance_for_event(event);
      	if (typeof(instance) != "undefined") {
          return instance;
        }
      } else {
	      var instance = $store.getters.instance_for_channel(ch);
  	    if (typeof(instance) != "undefined") {
    	    return instance;
      	}
      }
    }
    return undefined;
	},
	status_all () {
		return $store.state.channel_status;
	},
	event_form (channel) {
		if(!channel.meta.event_form) return undefined;
		return SettingsModel.get_by_name(channel.meta.event_form);
	},
	types () {
		return [
    		{label: "Input", value: "input"},
    		{label: "Output", value: "output"}
    ];
	},
	notifiers () {
		return SettingsModel.list("external_notifier");
	},
	transcoder_sizes () {
		return [
      {name: "4x", value: "4x"},
      {name: "8x", value: "8x"},
      {name: "16x", value: "10x"},
      {name: "16x", value: "12x"},
      {name: "36x", value: "36x"},
      {name: "48x", value: "48x"},
      {name: "72x", value: "72x"},
      {name: "AMD Gen 6 4x", value: "a4x"},
      {name: "AMD Gen 6 8x", value: "a8x"},
      {name: "AMD Gen 6 16x", value: "a16x"},
      {name: "AMD Gen 6 32x", value: "a32x"},
      {name: "AMD Gen 6 48x", value: "a48x"},
      {name: "AMD Gen 6 64x", value: "a64x"},
      {name: "AMD Gen 6 96x", value: "a96x"},
      {name: "AMD Gen 7 4x", value: "7a4x"},
      {name: "AMD Gen 7 8x", value: "7a8x"},
      {name: "AMD Gen 7 16x", value: "7a16x"},
      {name: "AMD Gen 7 32x", value: "7a32x"},
      {name: "AMD Gen 7 48x", value: "7a48x"},
      {name: "AMD Gen 7 64x", value: "7a64x"},
      {name: "AMD Gen 7 96x", value: "7a96x"},
      {name: "GPU Gen 5 4x", value: "5g4x"},
      {name: "GPU Gen 5 8x", value: "5g8x"},
      {name: "GPU Gen 5 16x", value: "5g16x"},
      {name: "GPU Gen 5 32x", value: "5g32x"},
      {name: "GPU Gen 5 48x", value: "5g48x"},
      {name: "GPU Gen 5 64x", value: "5g64x"},
      {name: "GPU Gen 5 96x", value: "5g96x"},
      {name: "GPU Gen 5 192x", value: "5g192x"},
      {name: "GPU Gen 6 4x", value: "g4x"},
      {name: "GPU Gen 6 8x", value: "g8x"},
      {name: "GPU Gen 6 16x", value: "g16x"},
      {name: "GPU Gen 6 32x", value: "g32x"},
      {name: "GPU Gen 6 48x", value: "g48x"},
      {name: "GPU Gen 6 64x", value: "g64x"},
      {name: "GPU Gen 6 96x", value: "g96x"},
      {name: "GPU Gen 6 192x", value: "g192x"}
    ];
	}
}
